var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "share-svgrepo-com_4_",
    "data-name": "share-svgrepo-com (4)",
    d: "M18,1a4,4,0,0,0-3.959,4.572L8.448,8.836a4,4,0,1,0,0,6.327l5.593,3.259A4,4,0,1,0,18,15a3.982,3.982,0,0,0-2.444.833l-5.6-3.261a4.051,4.051,0,0,0,0-1.144l5.593-3.264A4,4,0,1,0,18,1Z",
    transform: "translate(-2 -1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2c390b04d3924dfd249da46a9a6cecb2.svg";
export { ForwardRef as ReactComponent };